<h1 mat-dialog-title>H&auml;ndler anlegen</h1>

<div mat-dialog-content (scroll)="onDialogContentScroll()">
    <kiene-haendler-details
        #haendlerDetailsComp
        [isDialog]="true"
        [haendler]="haendler"
        (saved)="dialogRef.close($event)"
    ></kiene-haendler-details>
</div>

<div mat-dialog-actions align="end">
    <button type="button" mat-button (click)="dialogRef.close()">Abbrechen</button>
    <button
        data-cy="haendler-details-save"
        mat-flat-button
        type="button"
        color="accent"
        (click)="save()"
        [disabled]="haendlerDetailsComp?.isLoading || !haendlerDetailsComp?.canEditHaendler"
    >
        {{ haendlerDetailsComp?.buttonText || 'Speichern' }}
    </button>
</div>
